// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';

// -- utils
import classNames from 'classnames';

// -- entities

class NumberButtonView extends Component {

  static propTypes = {
    value: PropTypes.number.isRequired,

    /**
     *  @param number
     */
    onSelect: PropTypes.func.isRequired,

    isSelected: PropTypes.bool
  };

  static defaultProps = {
    isSelected: false
  };

  onClick = () => {
    this.props.onSelect(this.props.value);
  };

  render() {
    const className = classNames('number_button_view', {
      selected: this.props.isSelected
    });
    return (
      <div
        className={className}
        onClick={this.onClick}
      >
        {this.props.value}
      </div>
    );
  }

}


export default NumberButtonView;



// WEBPACK FOOTER //
// ./sdk/scripts/components/form/NumberButtonView.js